/* eslint-disable no-param-reassign */

/* eslint-disable no-unused-vars */

/* eslint-disable react/no-array-index-key */

/* eslint-disable no-plusplus */

/* eslint-disable no-unused-expressions */

/* eslint-disable array-callback-return */

/* eslint-disable react/no-unused-state */

/* eslint-disable react/jsx-key */

/**
 *
 * VenueFilters
 *
 */

import Button from '@material-ui/core/Button'
import Checkbox from '@material-ui/core/Checkbox'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Grid from '@material-ui/core/Grid'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
/* eslint-disable no-nested-ternary */
import classNames from 'classnames/bind'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import shallowEqual from '../../utils/shallowEqual'
import PrimaryButton from '../Button/PrimaryButton'
import Icon from '../Icon'
import IconButton from '../IconButton'
import filterData from './fixtures/fixture.json'
import messages from './messages'

const styles = theme => ({
  root: {
    display: 'inline-block',
    flexWrap: 'wrap',
    width: '100%',
    float: 'left',
  },
  formControl: {
    width: '100%',
    border: theme.borders.default,
    borderRadius: '5px',
    backgroundColor: theme.colors.white,
  },
  selectEmpty: {
    marginTop: theme.spacing(8),
  },
  stgSelect: {
    background: 'transparent',
    '&:before': {
      borderBottom: 'none !important',
    },
    '&:after': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:focus': {
      background: 'none',
      borderBottom: 'none !important',
    },
    '&:hover': {
      borderBottom: 'none',
    },
    '& input': {
      padding: '0px',
    },
    '& .MuiSelect-selectMenu* ': {
      width: '90%',
    },
    '& div>div': {
      width: '100%',
      boxSizing: 'border-box',
      padding: '7px',
      fontSize: '14px',
    },
  },
  venueInnerContainer: {
    border: theme.borders.default,
    position: 'absolute',
    top: 40,
    right: 0,
    width: '425px',
    borderRadius: '4px',
    background: theme.colors.white,
    padding: '0',
    zIndex: '2',
    overflowY: 'auto',
    // height: '500px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  searchWrap: {
    width: '100%',
    padding: '0 15px',
    marginBottom: '16px',
  },
  textField: {
    margin: '0',
    border: theme.borders.default,
    padding: '7px 20px',
    background: '#fff',
    borderRadius: '4px',
    '& :before': {
      borderBottom: 'none',
      display: 'none',
    },
    '& :after': {
      borderBottom: 'none',
      display: 'none',
    },
    '& >div:hover': {
      borderBottom: 'none',
      ':before': {
        borderBottom: '0',
      },
    },
  },
  venueContainer: {
    height: '250px',
    overflow: 'auto',
    backgroundColor: `var(--gameday-inputField-inputBGHover, ${theme.inputField.inputBGHover})`,
    borderTop: theme.borders.default,
  },
  panel: {
    '&:before': {
      display: 'none',
    },
    backgroundColor: `var(--gameday-inputField-inputBGHover, ${theme.inputField.inputBGHover})`,
  },
  panelSummary: {
    padding: '8px 16px',
    minHeight: 'auto !important',
    '&>div': {
      margin: '0 !important',
    },
  },
  venueLabel: {
    margin: 0,
    backgroundColor: 'transparent',
  },
  playingSurfaceContainer: {
    padding: '0 30px 10px',
  },
  psCheckbox: {
    height: '30px',
  },
  textAlignRight: {
    textAlign: 'right',
    color: theme.palette.secondary.main,
    cursor: 'pointer',
  },
  selectAll: {
    padding: '0 20px 0 0',
  },
  topContainer: {
    padding: '16px 0 0',
  },
  countDiv: {
    marginRight: '6px',
    background: theme.colors.green,
    borderRadius: '12px',
    padding: '4px',
    color: theme.colors.white,
    fontWeight: 600,
    '&.lgCount': {
      padding: '10px',
      borderRadius: '4px',
      fontSize: '0.875rem',
    },
  },
  topHeading: {
    padding: '16px',
  },
  bottomFooter: {
    padding: '20px',
    borderTop: theme.borders.default,
    textAlign: 'right',
  },
  filterHeading: {
    float: 'left',
    margin: 0,
  },
  filterHeader: {
    display: 'flex',
    width: '100%',
    padding: '0 16px',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  crossIcon: {
    float: 'right',
    fontSize: '22px',
    width: '28px',
    height: '28px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  noFound: {
    textAlign: 'center',
  },
  whiteSpace: {
    whiteSpace: 'nowrap',
  },
  fontSize15: {
    fontSize: '15px',
  },
  centerContent: {
    textAlign: 'center',
  },
  alignCenter: {
    align: 'center',
  },
  cursorPointer: {
    cursor: 'pointer',
  },
  checkSpan: {
    marginRight: 20,
    marginLeft: 40,
    '&:hover': {
      color: 'red',
    },
  },
  checkboxGrid: {
    marginTop: 20,
  },
  displayInline: {
    display: 'flex',
  },
  middleContent2: {
    padding: '15px',
    marginLeft: '40px',
    marginBottom: '-45px',
  },
  selectAllSpan: {
    paddingLeft: '30px',
  },
  unSelectAll: {
    paddingLeft: '20px',
  },
  selectFilter: {
    color: theme.palette.primary.main,
  },
})

/* eslint-disable react/prefer-stateless-function */
class VenueFilter extends React.Component {
  constructor(props) {
    super(props)
    const res =
      props.filterData.length > 0
        ? this.createData(props.filterData)
        : props.filterData.length > 0 && props.notVenueData
          ? this.createData(props.filterData)
          : []

    this.state = {
      filteredData: props.filterData.length > 0 ? res[0] : [],
      selected: props.filterData.length > 0 ? res[1] : [],
      seletedVenue: props.filterData.length > 0 ? res[2] : [],
      open: false,
      expanded: null,
      searchText: '',
      callDataFirst: true,
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('click', e => this.handleClickOutside(e))
  }

  setWrapperRef = node => {
    this.wrapperRef = node
  }

  handleClickOutside = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ open: false })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps.filterData, this.props.filterData)) {
      const res = this.createData(nextProps.filterData ? nextProps.filterData : [])
      this.setState({
        filteredData: res[0],
        selected: res[1],
        seletedVenue: res[2],
      })
      /* code for initial call to getfixtures with all palying surface id */
      // const { callDataFirst } = this.state;
      // const selected = (Array.isArray(res) && res[1]) ? [...res[1],...res[2]] : [];
      // if (callDataFirst && (selected.length > 0) ) {
      //     if (selected.length > 0) {
      //       this.props.onChange(selected);
      //     } else {
      //       this.props.onChange(['noplayingsurfaces']);
      //     }
      //     this.setState({callDataFirst : false})
      //   }
    }

    if (nextProps.isOpenOverlay !== this.props.isOpenOverlay) {
      const { open } = this.state
      this.setState({ open: !open })
    }
  }

  createData = (isVenueChecked = true, isPlayingSurfaceChecked = true) => {
    const dataArr = []
    const psDataSelectedArr = []
    const venueDataArr = []
    let psCount = 0
    filterData[0].value.map(data => {
      const psDataArr = []
      Array.isArray(data.PlayingSurfaces) && data.PlayingSurfaces.length > 0
        ? data.PlayingSurfaces.map(ps => {
            const psObj = {
              playingSurfaceName: ps.playingSurfaceName,
              playingSurfaceType: ps.playingSurfaceType,
              playingsurfaceId: ps.playingsurfaceId,
              isChecked: isVenueChecked,
            }
            if (isPlayingSurfaceChecked && isVenueChecked) {
              psCount++
              if (psDataSelectedArr.indexOf(ps.playingsurfaceId) === -1) {
                psDataSelectedArr.push(ps.playingsurfaceId)
              }
            }
            psDataArr.push(psObj)
          })
        : isVenueChecked && isPlayingSurfaceChecked && this.props.notVenueData
          ? // biome-ignore lint/complexity/noCommaOperator: TODO
            (psCount++, psDataSelectedArr.push(data.name), venueDataArr.push(data.name))
          : venueDataArr.push(data.id)

      const obj = {
        name: data.name,
        id: data.id,
        isChecked: isPlayingSurfaceChecked,
        PlayingSurfaces: psDataArr,
      }
      // const finalObj = { obj};
      dataArr.push(obj)
    })
    const rawDataArr = [
      {
        key: 'Venues',
        key_prefix: '',
        value: dataArr,
        psCount,
      },
    ]

    return [rawDataArr, psDataSelectedArr, venueDataArr]
  }

  createfilteredData = () => {
    const { selected } = this.state
    const dataArr = []
    filterData[0].value.map(data => {
      const psDataArr = []
      let isCheckedRes = false
      // biome-ignore lint/complexity/useOptionalChain: TODO
      data.PlayingSurfaces &&
        data.PlayingSurfaces.map(ps => {
          isCheckedRes = selected.indexOf(ps.playingsurfaceId) !== -1
          const psObj = {
            playingSurfaceName: ps.playingSurfaceName,
            playingSurfaceType: ps.playingSurfaceType,
            playingsurfaceId: ps.playingsurfaceId,
            isChecked: isCheckedRes,
          }
          psDataArr.push(psObj)
        })
      const obj = {
        name: data.name,
        id: data.id,
        isChecked: isCheckedRes,
        PlayingSurfaces: psDataArr,
      }
      dataArr.push(obj)
    })
    const rawDataArr = [{ key: 'Venues', key_prefix: '', value: dataArr }]
    return rawDataArr
  }

  handleClick = () => {
    const { isOpenCallback } = this.props
    const { open } = this.state
    this.setState({ open: !open })
    isOpenCallback(!open)
  }

  handleSelectAllClick = () => {
    const { filteredData } = this.state
    const res = this.createData(filteredData)
    this.setState({
      filteredData: res[0],
      selected: res[1],
    })
  }

  handleNoneClick = () => {
    const { filteredData } = this.state
    const res = this.createData(filteredData, false, false)
    this.setState({
      filteredData: res[0],
      selected: res[1],
    })
  }

  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  handleVenueClick = (event, key) => {
    const { filteredData, selected } = this.state
    const tempFilteredData = [...filteredData]
    tempFilteredData[0].value[key].isChecked = !tempFilteredData[0].value[key].isChecked // prev case
    // already checked
    if (tempFilteredData[0].value[key].isChecked === false) {
      tempFilteredData[0].value[key].PlayingSurfaces.map(ps => {
        selected.splice(selected.indexOf(ps.playingsurfaceId), 1)
        // eslint-disable-next-line no-param-reassign
        ps.isChecked = false
      })
    } else if (this.props.notVenueData) {
      tempFilteredData[0].value.map(ps => {
        ps.isChecked = true
        if (selected.indexOf(ps.id) === -1) {
          selected.push(ps.name)
        }
      })
    } else {
      // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
      tempFilteredData[0].value[key].PlayingSurfaces.map((ps, i) => {
        ps.isChecked = true
        if (selected.indexOf(ps.playingsurfaceId) === -1) {
          selected.push(ps.playingsurfaceId)
        }
      })
    }
    this.setState({
      filteredData: tempFilteredData,
      selected,
    })
  }

  // biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
  handlePlayingSurfaceClick = (event, pkey, ckey) => {
    const { filteredData, selected } = this.state
    const tempFilteredData = [...filteredData]
    tempFilteredData[0].value[pkey].PlayingSurfaces[ckey].isChecked =
      !tempFilteredData[0].value[pkey].PlayingSurfaces[ckey].isChecked
    if (tempFilteredData[0].value[pkey].PlayingSurfaces[ckey].isChecked === true) {
      // already checked
      tempFilteredData[0].value[pkey].isChecked = true
      if (selected.indexOf(tempFilteredData[0].value[pkey].PlayingSurfaces[ckey].playingsurfaceId) === -1) {
        selected.push(tempFilteredData[0].value[pkey].PlayingSurfaces[ckey].playingsurfaceId)
      }
    } else {
      const totalCount = tempFilteredData[0].value[pkey].PlayingSurfaces.length
      let checkedCount = 0
      tempFilteredData[0].value[pkey].PlayingSurfaces.map(ps => {
        checkedCount = ps.isChecked === false ? checkedCount + 1 : checkedCount
      })
      if (checkedCount === totalCount) {
        tempFilteredData[0].value[pkey].isChecked = false
        selected.splice(tempFilteredData[0].value[pkey].PlayingSurfaces[ckey].playingsurfaceId, 1)
        // tempFilteredData[0].value[pkey].PlayingSurfaces.map((ps) => {
        // selected.splice(selected.indexOf(ps.playingsurfaceId), 1);
        // });
      } else {
        selected.splice(tempFilteredData[0].value[pkey].PlayingSurfaces[ckey].playingsurfaceId, 1)
      }
    }
    this.setState({
      filteredData: tempFilteredData,
      selected,
    })
  }

  handleSearch = searchText => {
    const res = this.props.filterData.length > 0 ? this.createfilteredData(this.props.filterData) : []
    // const {filteredData} = this.state;
    const tempFilteredData = res
    // var searchText = event.target.value;
    const tempArr = tempFilteredData[0].value.filter(data => {
      const psArr = data.PlayingSurfaces.filter(ps => {
        const stringText = ps.playingSurfaceType
          ? `${ps.playingSurfaceName}${ps.playingSurfaceType}`
          : `${ps.playingSurfaceName}`
        return stringText.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
      })
      const isPs = psArr.length > 0
      return data.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 || isPs
    })
    tempFilteredData[0].value = tempArr
    this.setState({
      filteredData: tempFilteredData,
      searchText: searchText.toLowerCase(),
    })
  }

  handleChange = () => {
    const { isOpenCallback } = this.props
    // const selected = [...this.state.selected, ...this.state.seletedVenue];
    const selected = [...this.state.selected]
    this.setState({ open: false, searchText: '' })
    this.handleSearch('')
    if (selected.length > 0) {
      this.props.onChange(selected)
    } else if (this.props.notVenueData || this.props.gameListVenue) {
      this.props.onChange([])
    } else {
      this.props.onChange(['noplayingsurfaces'])
    }
    isOpenCallback(false)
  }

  handleCross = () => {
    const { isOpenCallback } = this.props
    this.setState({ open: false })
    isOpenCallback(false)
  }

  render() {
    // biome-ignore lint/correctness/noUnusedVariables: TODO
    const { classes, checkedAll, uncheckedAll, heading, count, check, cancel, menuItem, selectedData, gameListVenue } =
      this.props
    // biome-ignore lint/correctness/noUnusedVariables: TODO
    const { filteredData, selected, open, searchText, expanded } = this.state

    let menuItemText

    if (selected.length > 0) {
      menuItemText = (
        <span>
          <span className={classes.countDiv}>{selected.length}</span>
          {selectedData || (
            <span>
              <FormattedMessage {...messages.playingSurface} />
              <FormattedMessage {...messages.selected} />
            </span>
          )}
        </span>
      )
    } else {
      menuItemText = menuItem || (
        <span>
          <FormattedMessage {...messages.select} />
          <FormattedMessage {...messages.playingSurface} />
        </span>
      )
    }

    return (
      <div autoComplete="on" className={classes.root} ref={this.setWrapperRef}>
        {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
        {filteredData &&
          filteredData.map((item, key) => (
            <FormControl
              key={`item${
                // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                key
              }`}
              className={classes.formControl}
            >
              <Select
                value=""
                displayEmpty
                name={item.key}
                readOnly
                className={classes.stgSelect}
                onClick={this.handleClick}
              >
                <MenuItem value="">{menuItemText}</MenuItem>
              </Select>
              {open && (
                <Grid container className={classes.venueInnerContainer}>
                  <Grid item xs={12} className={classes.topHeading}>
                    {heading ? (
                      <h3 className={classes.filterHeading}>
                        <FormattedMessage {...messages.venues} />
                      </h3>
                    ) : null}
                    <IconButton
                      onClick={event => this.handleCross(event)}
                      className={classes.crossIcon}
                      icon={<Icon iconName="close" iconSize="22" color="grey" />}
                    />
                  </Grid>
                  {count ? (
                    <div className={classes.filterHeader}>
                      <div>
                        {selected.length > 0 ? (
                          <React.Fragment>
                            <span className={classNames(classes.countDiv, 'lgCount')}>{selected.length}</span>
                            &nbsp;
                            <span>Selected</span>
                          </React.Fragment>
                        ) : null}
                      </div>
                      <div>
                        <span>
                          <Button className={classes.selectFilter} onClick={event => this.handleSelectAllClick(event)}>
                            Select All
                          </Button>
                        </span>
                        <span>
                          <Button className={classes.selectFilter} onClick={event => this.handleNoneClick(event)}>
                            None
                          </Button>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <Grid container className={classNames(classes.middleContent)}>
                      <Grid item xs={7} className={null}>
                        {selected.length > 0 ? (
                          <span className={classes.countDiv}>{selected.length}</span>
                        ) : (
                          <span>No</span>
                        )}
                        <span className={classNames(classes.noWrap, classes.fontSize15)}>
                          <FormattedMessage {...messages.playingSurfaceSelected} />
                        </span>
                      </Grid>
                      <Grid item xs={5} className={classNames(classes.textAlignRight)}>
                        <Button className={classes.selectAll} onClick={event => this.handleSelectAllClick(event)}>
                          {checkedAll}
                        </Button>
                        <Button
                          onClick={event => {
                            this.handleNoneClick(event)
                          }}
                        >
                          {uncheckedAll}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                  <Grid item xs={12} className={classNames(classes.topContainer, classes.middleContent)}>
                    <div className={classes.searchWrap}>
                      <TextField
                        id="search"
                        placeholder="search"
                        fullWidth
                        type="search"
                        className={classes.textField}
                        margin="normal"
                        value={searchText}
                        onChange={event => {
                          this.handleSearch(event.target.value)
                        }}
                      />
                    </div>
                    <div className={classes.venueContainer}>
                      {item.value.length > 0 ? (
                        item.value.map(option => (
                          // biome-ignore lint/correctness/useJsxKeyInIterable: TODO
                          <ExpansionPanel className={classes.panel}>
                            <ExpansionPanelSummary
                              expandIcon={
                                option.PlayingSurfaces.length > 0 && !gameListVenue ? <ExpandMoreIcon /> : null
                              }
                              className={classes.panelSummary}
                            >
                              <FormControlLabel
                                className={classes.venueLabel}
                                control={
                                  <Checkbox
                                    // checked={this.state.checkedB}
                                    onClick={event => {
                                      this.handleVenueClick(event, key)
                                    }}
                                    checked={option.isChecked}
                                    value={option.id}
                                    color="primary"
                                  />
                                }
                                label={
                                  gameListVenue
                                    ? `${option.name} - ${option.PlayingSurfaces[0].playingSurfaceName}`
                                    : option[`${item.key_prefix}name`]
                                }
                              />
                            </ExpansionPanelSummary>
                            {option.PlayingSurfaces.length > 0 && !gameListVenue ? (
                              <div className={classes.playingSurfaceContainer}>
                                {option.PlayingSurfaces.length > 0 ? (
                                  option.PlayingSurfaces.map((ps, key1) => (
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          // checked={this.state.checkedB}
                                          // onChange={this.handleChange('checkedB')}
                                          value={ps.playingsurfaceId}
                                          color="primary"
                                          checked={ps.isChecked}
                                          onClick={event => {
                                            this.handlePlayingSurfaceClick(event, key, key1)
                                          }}
                                          className={classes.psCheckbox}
                                        />
                                      }
                                      label={
                                        ps.playingSurfaceType
                                          ? `${ps.playingSurfaceName} - ${ps.playingSurfaceType}`
                                          : ps.playingSurfaceName
                                      }
                                      key={`playingSurface${
                                        // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                                        key1
                                      }`}
                                      className={classes.psLabel}
                                    />
                                  ))
                                ) : (
                                  <div className={classes.noFound}>No playing surface assigned</div>
                                )}
                              </div>
                            ) : null}
                          </ExpansionPanel>
                        ))
                      ) : (
                        <div className={classes.noFound}>No Data Found</div>
                      )}
                    </div>
                  </Grid>
                  <Grid item xs={12} className={classes.bottomFooter}>
                    <PrimaryButton onClick={this.handleChange}>Done</PrimaryButton>
                  </Grid>
                </Grid>
              )}
            </FormControl>
          ))}
      </div>
    )
  }
}

VenueFilter.defaultProps = {
  onChange: () => {},
  filterData,
  selected: [],
  checkedAll: 'Select All',
  uncheckedAll: 'None',
}

export default withStyles(styles)(VenueFilter)
